import { render, staticRenderFns } from "./PaperReport.vue?vue&type=template&id=46a815a0&scoped=true"
import script from "./PaperReport.vue?vue&type=script&lang=js"
export * from "./PaperReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a815a0",
  null
  
)

export default component.exports